// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"styles-module--mainTitle--nz3qL","image":"styles-module--image--3TuUQ"};